import axios from "axios";

const URL_BASE = `${process.env.ROOT_API}/exameAgendado`;

export default class ExameAgendadoService{
	static async salvar(form) {
		return axios.post(URL_BASE + "/salvar", form);
	}
	static async validar(form) {
		return axios.post(URL_BASE + "/validar", form);
	}
	static async consultar(id) {
		return axios.get(URL_BASE + "/consultar/" + id);
	}
	static async confirmarChamado(id) {
		return axios.post(URL_BASE + "/confirmarChamado/" + id);
	}
	static async deletar(id) {
		return axios.delete(URL_BASE + "/deletar/" + id);
	}
}



// WEBPACK FOOTER //
// ./src/service/ExameAgendadoService.js